import { get, includes } from 'lodash';
import { createLead, Origin } from '@lendi/lendigroup-leads-library';

import { FIELD_PATHS } from '@funnels/constants';
import { baseName as borrowingPowerBasename } from '@funnels/funnel-one/src/configs/borrowingPower.config';
import { baseName as newHomeLoanBasename } from '@funnels/funnel-one/src/configs/newHomeLoan.config';
import { baseName as refinanceBasename } from '@funnels/funnel-one/src/configs/refinance.config';
import { FormValuesFunnelOne } from '@funnels/types';
import { getLandingLocation } from '@funnels/utils';

import { generateBorrowingPowerSchemaData, generateFunnelSchemaData } from './generateSchemaData';

function getOrigin(): Origin.BorrowingPower | Origin.NewHomeLoan | Origin.Refinance | undefined {
  const origin = window.location.href;

  if (includes(origin, borrowingPowerBasename)) {
    return Origin.BorrowingPower;
  }
  if (includes(origin, newHomeLoanBasename)) {
    return Origin.NewHomeLoan;
  }
  if (includes(origin, refinanceBasename)) {
    return Origin.Refinance;
  }
  return undefined;
}

export default function generateLead(funnelData: FormValuesFunnelOne) {
  const origin = getOrigin();
  if (!origin) {
    return;
  }

  const firstNameValue = get(funnelData, FIELD_PATHS.APPLICANT_FIRST_NAME(0));
  const basedata = {
    accountOrigin: getLandingLocation.href,
    ...(firstNameValue && { firstName: firstNameValue }),
  };

  switch (origin) {
    case Origin.BorrowingPower:
      const bpL3 = createLead(Origin.BorrowingPower);
      bpL3.set({
        origin,
        ...basedata,
        data: generateBorrowingPowerSchemaData(funnelData),
      });
      return bpL3;
    case Origin.NewHomeLoan:
      const nhlL3 = createLead(Origin.NewHomeLoan);
      nhlL3.set({
        origin,
        ...basedata,
        data: generateFunnelSchemaData(funnelData),
      });
      return nhlL3;
    case Origin.Refinance:
      const refiL3 = createLead(Origin.Refinance);
      refiL3.set({
        origin,
        ...basedata,
        data: generateFunnelSchemaData(funnelData),
      });
      return refiL3;
  }
}
